export default __webpack_public_path__ + "static/media/qhmovie.fcf085d2.png";